export const filters = () => {
    const $ = jQuery;

    const filter_forms = $('.filters-form, .mobile-filters-form');
    const timeframeRadios = $('input[name="timeframe"]');

    if (filter_forms.length === 0) {
        return true;
    }

    $.each(filter_forms, (i, form) => {
        const clearButton = $(form).find('.clear-button, .all-filter-wrapper');
        const applyButton = $(form).find('.apply-button');
        const filterTriggers = $(form).find('.filter-heading');
        const close = $(form).find('.header-wrapper .close');
        const allInputs = $(form).find('input.all-input');
        const inputs = $(form).find('input.filter-input');

        const closeMobileFilters = () => {
            $('#archive-mobile-filters').slideUp({duration: 300, complete: () => {
                $('body').removeClass('show-overlay');
                $('#archive-mobile-filters').find('.filter-list');
            }});
        }

        const closeFilters = () => {
            filter_forms.find('.filter-wrapper.open').removeClass('open').children('.filter-list').slideUp(300);
        }

        const handleClose = (e) => {
            e.preventDefault();

            closeMobileFilters();
            closeFilters();
        }

        const handleClear = (e) => {
            closeMobileFilters();
            closeFilters();

            return true;
        }

        const handleAllChange = (e) => {
            const isChecked = $(e.currentTarget).is(':checked');
            const inputs = $(e.currentTarget).parents('.filter-list').find('input.filter-input')

            if (isChecked) {
                inputs.filter(':checked').prop('checked', '');
            } else {
                inputs.prop('checked', 'checked');
            }
        }

        const handleInputChange = (e) => {
            const isChecked = $(e.currentTarget).is(':checked');
            const inputs = $(e.currentTarget).parents('.filter-list').find('input.filter-input').not(e.currentTarget);
            const allInput = $(e.currentTarget).parents('.filter-list').find('input.all-input');
            
            const mirrorId = (e.currentTarget.id.toLowerCase().indexOf("mobile-") >= 0) ? e.currentTarget.id.replace('mobile-', '') : 'mobile-' + e.currentTarget.id;

            const mirrorInput = $('input#' + mirrorId);

            if (isChecked) {
                allInput.prop('checked', '');
                mirrorInput.prop('checked', 'checked');
            } else if (inputs.filter(':checked').length === 0) {
                allInput.prop('checked', 'checked');
            } else {
                mirrorInput.prop('checked', '');
            }
        }

        const handleApply = (e) => {
            closeMobileFilters();
            closeFilters();

            return true;
        }

        const handleFilterTrigger = (e) => {
            e.preventDefault();

            const activeFilter = $(e.currentTarget).parents('.filter-wrapper');
            const openFilter = $(e.currentTarget).parents('.filters-wrapper').children('.filter-wrapper.open').not(activeFilter);
            
            if ( ! activeFilter.hasClass('open') ) {
                openFilter.removeClass('open').children('.filter-list').slideUp(300);
            }

            activeFilter.toggleClass('open').children('.filter-list').slideToggle(300);
        }

        close.on('click', handleClose);
        clearButton.on('click', handleClear);
        applyButton.on('click', handleApply);
        filterTriggers.on('click', handleFilterTrigger);

        allInputs.on('change', handleAllChange);
        inputs.on('change', handleInputChange);
    });

    const mobileTrigger = $('#mobile-trigger-filters');

    if (mobileTrigger.length === 0) {
        return true;
    }

    const handleTrigger = (e) => {
        e.preventDefault();

        $('body').addClass('show-overlay');
        
        setTimeout(() => {
            $('#archive-mobile-filters').slideDown(300);
        }, 50);
    }

    mobileTrigger.on('click', handleTrigger);
    $(document).on('click', '.mobile-trigger-filters', handleTrigger);

    if (timeframeRadios.length && !timeframeRadios.filter(':checked').length) {
        timeframeRadios.first().prop('checked', true).trigger('change');
    }
};